import styled from 'styled-components';

const Wrapper = styled.div`
	padding: 0 50px;
	.wallet-header {
		position: relative;
		padding-left: 78px;
		.wallet-header-img {
			width: 80px;
			height: 80px;
			position: absolute;
			left: 0;
			top: 10px;
			z-index: 1;
			background-size: cover;
		}
	}
	.ant-page-header-heading-title {
		display: block;
	}
	.ant-page-header-heading-sub-title {
		white-space: normal;
	}
	.coin-list {
		display: block;
		margin-top: 22px;
		> * {
			display: inline-block;
			margin-bottom: 22px;
			margin-right: 22px;
		}
	}
	.wallet-list {
		padding: 24px 0;
		h2 {
			border-top: 2px solid #000;
		}
		.button-wrapper {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 8px;
			.filter-area {
				display: flex;
			}
			.ant-select {
				min-width: 160px;
				max-width: 160px;
				.ant-select-selection {
					border-radius: 0;
				}
			}
			.ant-input-affix-wrapper {
				min-width: 200px;
				max-width: 200px;
				.ant-input {
					border-radius: 0;
				}
			}
		}
	}
	@media (max-width: 1200px) {
		padding: 0;
		margin-top: 12px;
		.wallet-header {
			padding-left: 0;
			.wallet-header-img {
				display: none;
			}
		}
		.wallet-list {
			padding: 0 24px;
			.button-wrapper {
				text-align: left;
				align-items: flex-end;
				.filter-area {
					flex-direction: column;
				}
			}
		}
	}
`;

export const TokenWrapper = styled.div`
	padding: 24px 0;
	h2 {
		border-top: 2px solid #000;
	}
	.button-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
		.ant-select {
			min-width: 160px;
			max-width: 160px;

			.ant-select-selection {
				border-radius: 0;
			}
		}
	}
	.tkn-label {
		cursor: pointer;
		i {
			text-decoration: underline;
			font-style: normal;
		}
		&.disabled {
			color: #ff0000;
		}
		&.active-btn {
			color: #0000ff;
		}
	}
	@media (max-width: 1200px) {
		padding: 24px 12px;
	}
`;

export const DescriptionWrapper = styled.div`
	padding: 24px 0px;
	width: 100%;
	.title-description {
		display: flex;
		justify-content: space-between;
	}
	.table-wrap {
		.flex-col {
			display: flex;
			align-items: center;
		}
		.coin-wrap {
			margin-right: 5px;
		}
	}
`;

export default Wrapper;
